document.querySelectorAll(".form").forEach((form) => {
  form.addEventListener("submit", function () {
    const submitButton = this.querySelector('[type="submit"]');
    // Prevent errors if form does not contain a submit button
    if (submitButton) {
      submitButton.disabled = true;
    }
  });
});
